import type { FC } from "react"

import type { Phase } from "@logic/lib/design"
import { useTranslation } from "react-i18next"
import { useRecoilState, useRecoilValue } from "recoil"

import ToggleButton from "~/components/ToggleButton"
import {
  currentUserIsDesignRequestUserState,
  userHasRequiredPermissionsState,
} from "~/containers/Proposal/state/user/user-state"
import { useTriggerPreventionToast } from "~/hooks/useTriggerPreventionToast"

import { AutoPlacementPanelButton } from "./AutoPlacePanelButton"
import { isSnappingOnState, panelFillState } from "../state/elements/panels"
import { PANEL_ACTIVATION_ALLOWED_PERMISSIONS } from "../state/phase"

const ToggleTransparencyButton: FC = () => {
  const { t } = useTranslation()
  const [panelFill, setPanelFill] = useRecoilState(panelFillState)
  const isPanelOpaque = panelFill === `Opaque`

  return (
    <ToggleButton
      label={t(`toggleTransparency`)}
      setAction={() => setPanelFill(isPanelOpaque ? `Transparent` : `Opaque`)}
      isActive={!isPanelOpaque}
    />
  )
}

const TogglePanelSnapButton: FC = () => {
  const { t } = useTranslation()
  const [isSnapOn, setIsSnapOn] = useRecoilState(isSnappingOnState)

  return (
    <ToggleButton
      label={t(`toggleSnap`)}
      setAction={() => setIsSnapOn(!isSnapOn)}
      isActive={isSnapOn}
    />
  )
}

/* eslint-disable react-hooks/rules-of-hooks */
export const PhaseOptionsFor: Record<Phase, FC> = {
  "Image Selection": () => null,
  "Outline": () => null,
  "Edge Designation": () => null,
  "Roof Attributes": () => null,
  "Panel Placement": () => {
    return (
      <>
        <AutoPlacementPanelButton />
        <ToggleTransparencyButton />
        <TogglePanelSnapButton />
      </>
    )
  },
  "Panel Activation": () => {
    const hasRequiredActivationPermissions = useRecoilValue(
      userHasRequiredPermissionsState(PANEL_ACTIVATION_ALLOWED_PERMISSIONS),
    )

    return hasRequiredActivationPermissions ? <ToggleTransparencyButton /> : null
  },
}
